import React, { Component } from "react";

import {
  CardContent,
  ListSubheader,
  ListItemText,
  ListItem,
  ListItemIcon,
  List,
  Typography
} from "material-ui";

import KeyboardArrowRightIcon from "material-ui-icons/KeyboardArrowRight";

const style = {
  details: {
    paddingLeft: "16px",
    paddingRight: "16px",
    lineHeight: "24px",
    fontSize: "16px",
    whiteSpace: "pre-line"
  },
  wrap:{
    overflow: 'hidden',
    display: '-webkit-box',
    WebkitLineClamp: '3',
    WebkitBoxOrient: 'vertical',
    paddingLeft: "16px",
    paddingRight: "16px",
    lineHeight: "24px",
    fontSize: "16px",
    whiteSpace: "pre-line"
  },
  listItem: {
    paddingTop: "0",
    paddingBottom: "0"
  },
  listItemText: {
    paddingLeft: "0"
  }
};

export default class JobCardContent extends Component {
  render() {
    const { job, wrap, loading } = this.props;
    return (
      <CardContent>
        {!!loading ?
          <React.Fragment>
            <Typography className='titleSkeleton'> ~ </Typography>
            <Typography className='titleSkeleton'> ~ </Typography>
            <Typography className='titleSkeleton'> ~ </Typography>
          </React.Fragment>
        :
          <List subheader>
            {!wrap && (
              <ListSubheader disableSticky>{`About ${job.company}`}</ListSubheader>
            )}
            {!wrap && (
              <Typography style={style.details} noWrap={!wrap}>
                {job.about}
              </Typography>
            )}
            <ListSubheader disableSticky>{`Job Details`}</ListSubheader>
            <Typography style={!wrap ? style.details : style.wrap} noWrap={!wrap}>
              {job.details}
            </Typography>
            {!wrap &&
              job.responsibilities &&
              job.responsibilities.length !== 0 && (
                <ListSubheader
                  disableSticky
                >{`Job Responsibilities`}</ListSubheader>
              )}
            {!wrap &&
              job.responsibilities &&
              job.responsibilities.length !== 0 &&
              job.responsibilities.map((responsibility, i) => {
                return (
                  <ListItem style={style.listItem} key={`item-${i}`}>
                    <ListItemIcon>
                      <KeyboardArrowRightIcon />
                    </ListItemIcon>
                    <ListItemText
                      style={style.listItemText}
                      primary={responsibility}
                    />
                  </ListItem>
                );
              })}

            {!wrap &&
              job.qualifications &&
              job.qualifications.length !== 0 && (
                <ListSubheader
                  disableSticky
                >{`Candidate Qualifications`}</ListSubheader>
              )}
            {!wrap &&
              job.qualifications &&
              job.qualifications.length !== 0 &&
              job.qualifications.map((qualification, i) => {
                return (
                  <ListItem style={style.listItem} key={`item-${i}`}>
                    <ListItemIcon>
                      <KeyboardArrowRightIcon />
                    </ListItemIcon>
                    <ListItemText
                      style={style.listItemText}
                      primary={qualification}
                    />
                  </ListItem>
                );
              })}
          </List>
        }
      </CardContent>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/JobCardContent.js